export const css = {
    root: '_8jLeifg7',
    splash: '_1CnYW8yD',
    progressBar: '_3_Gv9qVo',
    dynamicRoot: '_1STz41GC',
    dynamicContainer: '_1oUqqoof',
    textContainer: '_2KMJrDq6',
    dynamicText: 'Xoo8YB2H',
    ' _key': 'lcc-app/splash'
};
export default css;
